export class DatadogTransport {
    level;
    log;
    constructor(opts) {
        this.level = opts.level || 'info';
        this.log = (message, meta = {}, level) => {
            // LogLevel maps directly to datadogLogsInstance logger methods
            if (message instanceof Error) {
                // Datadog logger has an optional third error param for exception handling
                opts.datadogLogsInstance.logger[level](message.message, meta, message);
            }
            else if (typeof message === 'string' && meta instanceof Error) {
                opts.datadogLogsInstance.logger[level](message, {}, meta);
            }
            else if (typeof message === 'string') {
                opts.datadogLogsInstance.logger[level](message, meta);
            }
            else {
                // Datadog requires a string for the message param. Our downstream usage currently provides
                // either a string or an Error, but for future-proofing this just stringify the unknown object as message.
                opts.datadogLogsInstance.logger[level](JSON.stringify(message), meta);
            }
        };
    }
}
//# sourceMappingURL=datadog.js.map